export default __webpack_public_path__ + "static/media/do.75e69c18.svg";